import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-538fafe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["dir"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["dir"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["dir"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope-open" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-adjust" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "lang-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe-africa" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "lang-dropdown"
}

import { ref, computed } from 'vue';
  import Header from '@/components/HomePage.vue';
  import About from '@/components/About.vue';
  import Portfolio from '@/components/Portfolio.vue';
  import Blogs from '@/components/Blogs.vue';
  import Contact from '@/components/Contact.vue';
  import { useI18n } from 'vue-i18n';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  const isLightMode = ref<boolean>(false);
  const activeSection = ref<string>('home');
  const { locale } = useI18n();
  
  const toggleTheme = () => {
    isLightMode.value = !isLightMode.value;
    document.body.classList.toggle('light-mode', isLightMode.value);
  };
  
  const HandleSections = (id: string) => {
    activeSection.value = id;
  };
  
  const isDropdownVisible = ref(false);
  
  const toggleDropdown = () => {
    console.log('Dropdown toggle clicked:', isDropdownVisible.value); // Debugging log
    isDropdownVisible.value = !isDropdownVisible.value;
    console.log('Dropdown now:', isDropdownVisible.value); // Debugging log
  };
  
  const setLanguage = (lang: string) => {
    console.log('Language selected:', lang);
    // Add logic here to change the language of your application
    locale.value = lang;
    isDropdownVisible.value = false;
  };
  // Computed property to determine if the current language is RTL
const isRTL = computed(() => {
  return locale.value === 'ar'; // 'ar' is the code for Arabic
});
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["container header", { active: activeSection.value === 'home' }]),
      id: "home"
    }, [
      _createVNode(Header)
    ], 2),
    _createElementVNode("main", null, [
      _createElementVNode("section", {
        class: _normalizeClass(["container about", { active: activeSection.value === 'about' }]),
        id: "about"
      }, [
        _createVNode(About)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(["container", { active: activeSection.value === 'portfolio' }]),
        id: "portfolio"
      }, [
        _createVNode(Portfolio)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(["container", { active: activeSection.value === 'blogs' }]),
        id: "blogs"
      }, [
        _createVNode(Blogs)
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(["container contact", { active: activeSection.value === 'contact' }]),
        id: "contact"
      }, [
        _createVNode(Contact)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["control", { 'active-btn': activeSection.value === 'home' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (HandleSections('home')))
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["control", { 'active-btn': activeSection.value === 'about' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (HandleSections('about'))),
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, _hoisted_7, 10, _hoisted_5),
      _createElementVNode("div", {
        class: _normalizeClass(["control", { 'active-btn': activeSection.value === 'blogs' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (HandleSections('blogs'))),
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, _hoisted_10, 10, _hoisted_8),
      _createElementVNode("div", {
        class: _normalizeClass(["control", { 'active-btn': activeSection.value === 'contact' }]),
        "data-id": "contact",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (HandleSections('contact'))),
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, _hoisted_13, 10, _hoisted_11)
    ]),
    _createElementVNode("div", {
      class: "theme-btn",
      onClick: toggleTheme
    }, _hoisted_15),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        class: "lang-btn",
        onClick: toggleDropdown
      }, _hoisted_18),
      (isDropdownVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (setLanguage('en')))
              }, "English"),
              _createElementVNode("li", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (setLanguage('fr')))
              }, "Français"),
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (setLanguage('ar')))
              }, "عربي")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})